import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  userManagementProfileURL,
  getUserManagementProfileUpdateURL,
  getFinancialReportURL,
  getFinancialReportDownloadURL,
  getFinancialGenerateReportUrl,
  getFinancialFetchReportUrl,
  getCreditScoreManualUploadUrl,
  navItemsURL,
  getFinacialReportDataUrl,
  getUserBankAccountUpdateUrl,
  getUserPropertyEnquiryUrl,
  getUserPropertyOrderDocUrl,
  getCustomerStatusApprovelUrl,
  getAutoswitchingUrl,
  getUserPromoCodeUrl,
  getDeleteCreditScoreUrl,
  getFinancialCreditScoreUrl,
  getOwnerCreditScoreUrl,
  getOrganizationIdUrl,
  getOrganizationInqueryAcnUrl,
  getOrganizationInqueryAbnUrl,
  getCreditScoreDataForUpdateUrl,
  getCreditScoreUpdateUrl,
  getOwnerEquifaxIdUrl,
  getDeactivateUserURL,
  getUserManagementResendURL,
  getUserManagementDeleteURL,
  getSlectedDeletedURL,
  getHandleLoginUserURL,
  getLoadUserDataURL,
  getUserSalesLeadsURL,
  getSecondaryUsersDataURL,
  getUserManagementUsersDataURL,
  getUserCountryInfoURL,
  getCorporateCommentDataURL,
  getUpdateTrustCorporatesURL,
  getDirectDebitUrl,
  getGocardLessBankAccUrl,
  getUserMetadataUpdateURL,
  getUserManagementInitURL,
  getUserManagementClientDetailsURL
} from "../utils/constants/apiEndPoints";
import { showToast } from "../utils/utils";
import {
  MISSING_ACCESS_TOKEN_COOKIE,
  showToastType
} from "../utils/constants/appConstants";
import {
  commonErrMsg,
  customerTab,
  fileDownloadMessages,
  userManage
} from "../locales/en";
import { HTTP_STATUS_SUCCESS } from "../utils/constants/appConstants";
import privateAxios from "../utils/axiosPrivate";
const initialState = {
  profile: {},
  usersData: {},
  secondaryUsersData: null,
  usersLoading: false,
  notFoundUserData: false,
  navItems: null,
  profileLoading: false,
  navItemsLoading: false,
  loading: false,
  userAddress: [],
  customerStatusData: null,
  statusInfo: false,
  creditScroeLoading: false,
  aiCreditScroeDataLoading: false,
  aiCreditScroeAcnLoading: false,
  userManagementLoading: false,
  creditScoreData: [],
  userSalseLeadData: [],
  userManagmentInitData: null,
  userManagmentInitLoading: false,
  userManagmentClientsData: null,
  directDebitData: null
};
const userManagementSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    setProfile(state, action) {
      state.profile = action.payload;
    },
    setUsersData(state, action) {
      state.usersData = action.payload;
    },
    // FV2-807: lets a component that just saved a credit limit through its own
    // endpoint (Funding.jsx) patch the cached copy in place, so every other
    // component reading usersData sees the fresh value without a refetch.
    setUsersDataCreditLimit(state, action) {
      const { userAccountId, creditLimit } = action.payload;
      // Guard against a save for one customer resolving after the admin has
      // already navigated to another - usersData.id is whichever customer is
      // current now, so only apply the patch if it still matches.
      if (
        state.usersData?.userAccountMeta &&
        state.usersData?.id === userAccountId
      ) {
        state.usersData.userAccountMeta.creditLimit = creditLimit;
      }
    },
    setSecondaryUsersData(state, action) {
      state.secondaryUsersData = action.payload;
    },
    setProfileLoading(state, action) {
      state.profileLoading = action.payload;
    },
    setNavItems(state, action) {
      state.navItems = action.payload;
    },
    setNavItemsLoading(state, action) {
      state.navItemsLoading = action.payload;
    },
    setUserAddress: (state, action) => {
      state.userAddress = action.payload;
    },
    setStatusInfo(state, action) {
      state.statusInfo = action.payload;
    },
    setCreditScoreData(state, action) {
      state.creditScoreData = action.payload;
    },
    setUserSalseLeadData(state, action) {
      state.userSalseLeadData = action.payload;
    }
  },
  extraReducers: (builder) => {
    // Handle propertySearchCreate
    builder
      .addCase(propertySearchCreate.pending, (state) => {
        state.loading = true;
      })
      .addCase(propertySearchCreate.fulfilled, (state, action) => {
        state.loading = false;
        showToast(action.payload.data.message, showToastType.success);
      })
      .addCase(propertySearchCreate.rejected, (state, action) => {
        state.loading = false;
        showToast(action.payload.data.message, showToastType.error);
      })

      // Handle Update profile
      .addCase(updateProfile.fulfilled, () => {
        showToast(customerTab?.details.errMsg.item3, showToastType.success);
      })
      .addCase(updateProfile.rejected, (state, action) => {
        const errorData = action.payload?.data;
        const errorMsg =
          errorData?.errors?.[0] || errorData?.message || commonErrMsg?.item2;
        showToast(errorMsg, showToastType.error);
      })

      // Handle propertySearchCreate
      .addCase(getUserPropertyOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserPropertyOrder.fulfilled, (state, action) => {
        state.loading = false;
        showToast(action.payload.data.data.message, showToastType.success);
      })
      .addCase(getUserPropertyOrder.rejected, (state, action) => {
        state.loading = false;
        showToast(action.payload.data.message, showToastType.error);
      })

      // Handle getUsersData
      .addCase(getUsersData.pending, (state) => {
        state.usersLoading = true;
        state.notFoundUserData = false;
      })
      .addCase(getUsersData.fulfilled, (state) => {
        state.usersLoading = false;
        state.notFoundUserData = false;
      })
      .addCase(getUsersData.rejected, (state) => {
        state.usersLoading = false;
        state.notFoundUserData = true;
      })

      // Handle getSecondaryUsersData
      .addCase(getSecondaryUsersData.pending, (state) => {
        state.secondaryUsersData = null;
      })
      .addCase(getSecondaryUsersData.fulfilled, (state, action) => {
        const secondaryUser = action?.payload?.data?.data || [];
        const secondaryUserFilterData = [...secondaryUser].sort(
          (a, b) => a.id - b.id
        );
        state.secondaryUsersData = secondaryUserFilterData;
      })

      // Handle getCustomerStatusData
      .addCase(getCustomerStatusData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerStatusData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getCustomerStatusData.rejected, (state, action) => {
        state.loading = false;
        state.customerStatusData = action?.payload?.data?.errors || null;
        state.statusInfo = true;
      })

      // Handle createAutoSwitchingData
      .addCase(createAutoSwitchingData.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAutoSwitchingData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createAutoSwitchingData.rejected, (state) => {
        state.loading = false;
        showToast(
          state?.customerStatusData?.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle delete credit score
      .addCase(deleteCreditScore.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCreditScore.fulfilled, (state, action) => {
        state.loading = false;
        showToast(action.payload.data.message, showToastType.success);
      })
      .addCase(deleteCreditScore.rejected, (state) => {
        state.loading = false;
        showToast(
          state?.customerStatusData?.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getFinancialCreditScore
      .addCase(getFinancialCreditScore.pending, (state) => {
        state.creditScroeLoading = true;
      })
      .addCase(getFinancialCreditScore.fulfilled, (state, action) => {
        state.creditScroeLoading = false;
        showToast(action.payload.data.message, showToastType.success);
      })
      .addCase(getFinancialCreditScore.rejected, (state, action) => {
        state.creditScroeLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getOwnerCreditScore
      .addCase(getOwnerCreditScore.pending, (state) => {
        state.creditScroeLoading = true;
      })
      .addCase(getOwnerCreditScore.fulfilled, (state, action) => {
        state.creditScroeLoading = false;
        showToast(action.payload.data.message, showToastType.success);
      })
      .addCase(getOwnerCreditScore.rejected, (state, action) => {
        state.creditScroeLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getAICreditScoreData
      .addCase(getCreditScoreManualUploadData.pending, (state) => {
        state.aiCreditScroeDataLoading = true;
      })
      .addCase(getCreditScoreManualUploadData.fulfilled, (state) => {
        state.aiCreditScroeDataLoading = false;
      })
      .addCase(getCreditScoreManualUploadData.rejected, (state) => {
        state.aiCreditScroeDataLoading = false;
      })

      // Handle getOrganizationIDCreditScore
      .addCase(getOrganizationIDCreditScore.pending, (state) => {
        state.creditScroeLoading = true;
      })
      .addCase(getOrganizationIDCreditScore.fulfilled, (state) => {
        state.creditScroeLoading = false;
      })
      .addCase(getOrganizationIDCreditScore.rejected, (state, action) => {
        state.creditScroeLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getEquifaxCreditScore
      .addCase(getEquifaxCreditScore.pending, (state) => {
        state.creditScroeLoading = true;
      })
      .addCase(getEquifaxCreditScore.fulfilled, (state) => {
        state.creditScroeLoading = false;
      })
      .addCase(getEquifaxCreditScore.rejected, (state, action) => {
        state.creditScroeLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getOrganizationInqueryAcn
      .addCase(getOrganizationInqueryAcn.pending, (state) => {
        state.aiCreditScroeAcnLoading = true;
      })
      .addCase(getOrganizationInqueryAcn.fulfilled, (state) => {
        state.aiCreditScroeAcnLoading = false;
      })
      .addCase(getOrganizationInqueryAcn.rejected, (state, action) => {
        state.aiCreditScroeAcnLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getOrganizationInqueryAbn
      .addCase(getOrganizationInqueryAbn.pending, (state) => {
        state.aiCreditScroeAcnLoading = true;
      })
      .addCase(getOrganizationInqueryAbn.fulfilled, (state) => {
        state.aiCreditScroeAcnLoading = false;
      })
      .addCase(getOrganizationInqueryAbn.rejected, (state, action) => {
        state.aiCreditScroeAcnLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getCreditScoreUpdateData
      .addCase(getCreditScoreUpdateData.pending, (state) => {
        state.aiCreditScroeAcnLoading = true;
      })
      .addCase(getCreditScoreUpdateData.fulfilled, (state) => {
        state.aiCreditScroeAcnLoading = false;
      })
      .addCase(getCreditScoreUpdateData.rejected, (state, action) => {
        state.aiCreditScroeAcnLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle getCreditScoreNewUpdateData
      .addCase(getCreditScoreNewUpdateData.pending, (state) => {
        state.aiCreditScroeAcnLoading = true;
      })
      .addCase(getCreditScoreNewUpdateData.fulfilled, (state) => {
        state.aiCreditScroeAcnLoading = false;
      })
      .addCase(getCreditScoreNewUpdateData.rejected, (state, action) => {
        state.aiCreditScroeAcnLoading = false;
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })
      // Handle delete user
      .addCase(userManagementDeleteThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(userManagementDeleteThunk.fulfilled, (state) => {
        state.loading = false;
        showToast(userManage.errMsg.item3, showToastType.success);
      })
      .addCase(userManagementDeleteThunk.rejected, (state) => {
        state.loading = false;
        showToast(commonErrMsg.item2, showToastType.error);
      })
      // Handle resend email
      .addCase(userManagementResendThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(userManagementResendThunk.fulfilled, (state, action) => {
        state.loading = false;

        const message =
          action.payload?.data?.message || userManage.errMsg.item3;
        showToast(message, showToastType.success);
      })
      .addCase(userManagementResendThunk.rejected, (state, action) => {
        state.loading = false;

        const errorData = action.payload;

        if (
          action.error?.message?.includes("500") ||
          errorData?.status === 500
        ) {
          const errors = errorData?.errors || [];
          showToast(errors.length ? errors.join(", ") : showToastType.error);
        } else {
          showToast(commonErrMsg.item2, showToastType.error);
        }
      })

      // Handle deleteUserFromData
      .addCase(deleteUserFromData.rejected, (action) => {
        showToast(
          action.payload.data.message || commonErrMsg.item2,
          showToastType.error
        );
      })

      // Handle deactivate user
      .addCase(userManagementDeactivateThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(userManagementDeactivateThunk.fulfilled, (state, action) => {
        state.loading = false;

        const message = action.payload?.data?.message;
        showToast(message, showToastType.success);
      })
      .addCase(userManagementDeactivateThunk.rejected, (state, action) => {
        state.loading = false;

        const errorData = action.payload;

        showToast(errorData.message, showToastType.error);
      })
      // Handle selected row deleted
      .addCase(userManagementSelecteddeletedThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(userManagementSelecteddeletedThunk.fulfilled, (state) => {
        state.loading = false;

        showToast(userManage.errMsg.item5, showToastType.success);
      })
      .addCase(userManagementSelecteddeletedThunk.rejected, (state, action) => {
        state.loading = false;

        const errorData = action.payload;

        showToast(errorData.message, showToastType.error);
      })
      // Updated login user
      .addCase(userManagementGetLoginUserURLThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        userManagementGetLoginUserURLThunk.fulfilled,
        (state, action) => {
          state.loading = false;

          const response = action.payload;

          if (response.status === 200) {
            const { accessToken, refreshToken } = response.data.data;

            if (accessToken && refreshToken) {
              showToast(userManage.errMsg.item9, showToastType.success);
            } else {
              const errorMessage =
                response.data?.message || userManage.errMsg.item6;
              showToast(errorMessage, showToastType.error);
            }
          } else {
            const errorMessage =
              response.data?.message || userManage.errMsg.item7;
            showToast(errorMessage, showToastType.error);
          }
        }
      )
      .addCase(userManagementGetLoginUserURLThunk.rejected, (state, action) => {
        state.loading = false;

        const errorData = action.payload;
        const errorMessage = errorData?.message || userManage.errMsg.item8;

        showToast(errorMessage, showToastType.error);
      })
      // load user data
      .addCase(userManagementLoadUserDataThunk.pending, (state) => {
        state.userManagementLoading = true;
      })
      .addCase(userManagementLoadUserDataThunk.fulfilled, (state) => {
        state.userManagementLoading = false;
      })
      .addCase(userManagementLoadUserDataThunk.rejected, (state, action) => {
        state.userManagementLoading = false;
        const errorData = action.payload;

        if (errorData?.status === 500) {
          showToast(
            errorData?.errors || userManage.errMsg.item8,
            showToastType.error
          );
        }
      })

      // Handle deactivate user
      .addCase(getUserBankAccountUpdateData.rejected, (state, action) => {
        const errorData = action.payload;
        showToast(errorData.message, showToastType.error);
      })

      .addCase(getUsersInitData.pending, (state) => {
        state.userManagmentInitLoading = true;
      })
      .addCase(getUsersInitData.fulfilled, (state, action) => {
        state.userManagmentInitLoading = false;
        state.userManagmentInitData = action.payload?.data?.data || null;
      })
      .addCase(getUsersInitData.rejected, (state, action) => {
        state.userManagmentInitLoading = false;
        showToast(action.payload?.data?.message, showToastType.error);
      })

      .addCase(getUsersClientDetailsData.fulfilled, (state, action) => {
        state.userManagmentClientsData = action.payload?.data?.data || null;
      })
      .addCase(getUsersClientDetailsData.rejected, (_, action) => {
        showToast(action.payload?.data?.message, showToastType.error);
      })

      .addCase(getUserDirectDebitData.fulfilled, (state, action) => {
        state.directDebitData = action.payload.data;
      })
      .addCase(getUserDirectDebitData.rejected, (_, action) => {
        showToast(action.payload?.data?.message, showToastType.error);
      });
  }
});

// Async thunk to get Profile data
export const getProfile = createAsyncThunk(
  "userManagement/getProfile",
  async (payload, { dispatch }) => {
    try {
      dispatch(setProfileLoading(true));
      const response = await privateAxios.get(userManagementProfileURL);
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setProfileLoading(false));
        dispatch(setProfile(response.data.data));
      }

      return response;
    } catch (error) {
      if (error?.response?.data?.message === MISSING_ACCESS_TOKEN_COOKIE) {
        // no need to show any toast message
      } else {
        showToast(commonErrMsg.item2, showToastType.error);
      }
      dispatch(setProfileLoading(false));
    } finally {
      dispatch(setProfileLoading(false));
    }
  }
);

// Async thunk to update Profile data
export const updateProfile = createAsyncThunk(
  "userManagement/updateProfile",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(
        getUserManagementProfileUpdateURL(payload)
      );
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        const state = getState();
        if (payload.id === state.userManagement?.profile?.id.toString()) {
          if (payload.key === "organizationName") {
            const updatedProfile = {
              ...state.userManagement.profile,
              businessDetails: {
                ...state.userManagement.profile.businessDetails,
                organizationName: payload.value
              },
              userAccountMeta: {
                ...state.userManagement.profile.userAccountMeta,
                legalName: payload.value
              },
              displayName: payload.value
            };
            dispatch(setProfile(updatedProfile));
            dispatch(getUsersInitData({ id: payload.id }));
          } else if (
            payload.key === "accountType" ||
            payload.key === "organizationType" ||
            payload.key === "nzbn" ||
            payload.key === "organizationId"
          ) {
            const updatedProfile = {
              ...state.userManagement.profile,
              businessDetails: {
                ...state.userManagement.profile.businessDetails,
                [payload.key]: payload.value
              }
            };
            dispatch(setProfile(updatedProfile));
          }
        }
      }
      // showToast(response.data.message, showToastType.success);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Async thunk to update Profile data
export const UserMetaDataUpdate = createAsyncThunk(
  "userManagement/UserMetaDataUpdate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(
        getUserMetadataUpdateURL(payload.id),
        {
          params: payload.params
        }
      );
      showToast(response.data.message, showToastType.success);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Async thunk to finanical report data
export const getFinancialReportData = createAsyncThunk(
  "userManagement/financialReport",
  async (payload, { dispatch }) => {
    try {
      dispatch(setProfileLoading(true));
      const response = await privateAxios.get(
        getFinancialReportURL(payload.id),
        {
          params: {
            reportType: payload.reportType,
            timePeriod: payload.timePeriod
          }
        }
      );
      return response;
    } catch (error) {
      dispatch(setProfileLoading(false));
      const apiError = error?.response?.data;
      const message =
        apiError?.errors?.length > 0
          ? apiError.errors.join(", ")
          : apiError?.message;
      showToast(message, showToastType?.error);
    } finally {
      dispatch(setProfileLoading(false));
    }
  }
);

// Async thunk to finanical report download
export const getFinancialReportDownload = createAsyncThunk(
  "userManagement/financialReportDownload",
  async (payload) => {
    try {
      const response = await privateAxios.get(getFinancialReportDownloadURL, {
        params: payload,
        responseType: "blob"
      });
      return response;
    } catch (error) {
      try {
        const text = await error.response.data.text();
        const errorJson = JSON.parse(text);
        showToast(
          errorJson?.errors?.[0] || errorJson?.message,
          showToastType?.error
        );
      } catch {
        showToast(
          fileDownloadMessages?.errors?.financialPdfReport,
          showToastType?.error
        );
      }
    }
  }
);

// Async thunk to finanical generate report
export const getFinancialGenerateReportData = createAsyncThunk(
  "userManagement/financialGenerateReportData",
  async (payload) => {
    try {
      const response = await privateAxios.get(
        getFinancialGenerateReportUrl(payload.id)
      );
      showToast(response.data?.message, showToastType?.success);
      return response;
    } catch {
      showToast(
        fileDownloadMessages?.errors?.financialPdfReport,
        showToastType?.error
      );
    }
  }
);

// Async thunk to finanical report download
export const getFinancialFetchReportData = createAsyncThunk(
  "userManagement/financialFetchReportData",
  async (payload) => {
    try {
      const response = await privateAxios.get(
        getFinancialFetchReportUrl(payload.id)
      );
      return response;
    } catch {
      // handle catch here;
    }
  }
);

// Async thunk to finanical report download
export const getFinancialFetchReportDataDownload = createAsyncThunk(
  "userManagement/financialFetchReportDataDownload",
  async (payload) => {
    try {
      const response = await privateAxios.get(
        getFinacialReportDataUrl(payload.id),
        {
          params: {
            reportType: payload.reportType
          }
        }
      );
      return response;
    } catch (error) {
      showToast(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0] ||
          fileDownloadMessages?.errors?.financialPdfReport,
        showToastType?.error
      );
    }
  }
);

// Async thunk to get nav items
export const getNavItems = createAsyncThunk(
  "userManagement/getNavItems",
  async (_, { dispatch }) => {
    try {
      dispatch(setNavItemsLoading(true));
      const response = await privateAxios.get(navItemsURL);
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setNavItems(response.data.data));
        dispatch(setNavItemsLoading(false));
        return response.data.data;
      }
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    } finally {
      dispatch(setNavItemsLoading(false));
    }
  }
);

// Async thunk to credit Score Data report
export const getCreditScoreManualUploadData = createAsyncThunk(
  "userManagement/creditScoreManualUploadData",
  async ({ payload, id }, { dispatch }) => {
    try {
      const response = await privateAxios.get(
        getCreditScoreManualUploadUrl(id),
        {
          params: payload
        }
      );
      dispatch(setCreditScoreData(response.data.data));
      return response.data;
    } catch {
      // handle catch here;
    }
  }
);

// async thunk bank account update
export const getUserBankAccountUpdateData = createAsyncThunk(
  "userManagement/userBankAccountUpdate",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(
        getUserBankAccountUpdateUrl(id),
        payload
      );
      if (response.status === 200) {
        showToast(response.data.message, showToastType.success);
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk Property search create
export const propertySearchCreate = createAsyncThunk(
  "userManagement/propertySearchCreate",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getUserPropertyEnquiryUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUserPropertyOrder = createAsyncThunk(
  "userManagement/getUserPropertyOrder",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getUserPropertyOrderDocUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk Customer status change
export const getCustomerStatusData = createAsyncThunk(
  "userManagement/getCustomerStatusData",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getCustomerStatusApprovelUrl(id));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk auto switching change
export const createAutoSwitchingData = createAsyncThunk(
  "userManagement/createAutoSwitchingData",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getAutoswitchingUrl(id), null, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk auto switching change
export const applyPromoCode = createAsyncThunk(
  "userManagement/applyPromoCode",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getUserPromoCodeUrl(id), null, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk delete credit score
export const deleteCreditScore = createAsyncThunk(
  "userManagement/deleteCreditScore",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(getDeleteCreditScoreUrl(id));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk delete User
export const deleteUserFromData = createAsyncThunk(
  "userManagement/deleteUserFromData",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(getUserManagementDeleteURL(id));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getFinancialCreditScore score
export const getFinancialCreditScore = createAsyncThunk(
  "userManagement/getFinancialCreditScore",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getFinancialCreditScoreUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getOwnerCreditScore score
export const getOwnerCreditScore = createAsyncThunk(
  "userManagement/getOwnerCreditScore",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getOwnerCreditScoreUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getOrganizationIDCreditScore score
export const getOrganizationIDCreditScore = createAsyncThunk(
  "userManagement/getOrganizationIDCreditScore",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getOrganizationIdUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getEquifaxCreditScore score
export const getEquifaxCreditScore = createAsyncThunk(
  "userManagement/getEquifaxCreditScore",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getOwnerEquifaxIdUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getOrganizationInqueryAcn score
export const getOrganizationInqueryAcn = createAsyncThunk(
  "userManagement/getOrganizationInqueryAcn",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getOrganizationInqueryAcnUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getOrganizationInqueryAbn score
export const getOrganizationInqueryAbn = createAsyncThunk(
  "userManagement/getOrganizationInqueryAbn",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getOrganizationInqueryAbnUrl(id),
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getCreditScoreUpdateData
export const getCreditScoreUpdateData = createAsyncThunk(
  "userManagement/getCreditScoreUpdateData",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getCreditScoreDataForUpdateUrl(id)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk getCreditScoreNewUpdateData score
export const getCreditScoreNewUpdateData = createAsyncThunk(
  "userManagement/getCreditScoreNewUpdateData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(getCreditScoreUpdateUrl, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk userManagementDelete
export const userManagementDeleteThunk = createAsyncThunk(
  "userManagement/userManagementDelete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(
        getUserManagementDeleteURL(Number(payload))
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// async thunk userManagementResend
export const userManagementResendThunk = createAsyncThunk(
  "userManagement/userManagementResend",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getUserManagementResendURL(Number(payload))
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// async thunk deactivate user
export const userManagementDeactivateThunk = createAsyncThunk(
  "userManagement/usermanagementDeactivate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(
        getDeactivateUserURL(Number(payload))
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// async thunk getUserSalesLeadsData
export const getUserSalesLeadsData = createAsyncThunk(
  "userManagement/getUserSalesLeadsData",
  async ({ id }, { rejectWithValue, dispatch }) => {
    try {
      const response = await privateAxios.get(getUserSalesLeadsURL(id));
      dispatch(setUserSalseLeadData(response.data.data));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Async thunk to get Users data
export const getUsersData = createAsyncThunk(
  "userManagement/getUsersData",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getUserManagementUsersDataURL(id)
      );
      if (
        response.status === 200 &&
        response.data.status === HTTP_STATUS_SUCCESS
      ) {
        dispatch(setUsersData(response.data.data));
      }

      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// async thunk selected deleted
export const userManagementSelecteddeletedThunk = createAsyncThunk(
  "userManagement/usermanagementSelectedDelete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getSlectedDeletedURL, payload);

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to get secondary Users data
export const getSecondaryUsersData = createAsyncThunk(
  "userManagement/getSecondaryUsersData",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getSecondaryUsersDataURL(id));
      dispatch(setSecondaryUsersData(response.data.data));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

//async get login user
export const userManagementGetLoginUserURLThunk = createAsyncThunk(
  "userManagement/userManagementGetLoginUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getHandleLoginUserURL(payload));
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
//async loaduser data
export const userManagementLoadUserDataThunk = createAsyncThunk(
  "userManagement/userManagementLoadUserData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getLoadUserDataURL, {
        params: payload.params
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to get Users country info data
export const getUsersCountryInfoData = createAsyncThunk(
  "userManagement/getUsersCountryInfoData",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getUserCountryInfoURL(id));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUsersCommentsData = createAsyncThunk(
  "userManagement/getUsersCommentsData",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getCorporateCommentDataURL(id), {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getTrustCorporateData = createAsyncThunk(
  "userManagement/getTrustCorporateData",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getUpdateTrustCorporatesURL(id));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUserDirectDebitData = createAsyncThunk(
  "userReport/getUserDirectDebitData",
  async (payload, { rejectWithValue }) => {
    try {
      const paramsConfig = {
        params: payload
      };
      const response = await privateAxios.get(getDirectDebitUrl, paramsConfig);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUserGoCardlessBankData = createAsyncThunk(
  "userReport/getUserGoCardlessBankData",
  async (payload, { rejectWithValue }) => {
    try {
      const paramsConfig = {
        params: payload
      };
      const response = await privateAxios.get(
        getGocardLessBankAccUrl,
        paramsConfig
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUsersInitData = createAsyncThunk(
  "userManagement/getUsersInitData",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getUserManagementInitURL(id));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getUsersClientDetailsData = createAsyncThunk(
  "userManagement/getUsersClientDetailsData",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getUserManagementClientDetailsURL(id)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const {
  setProfile,
  setProfileLoading,
  setNavItems,
  setNavItemsLoading,
  setUserAddress,
  setStatusInfo,
  setCreditScoreData,
  setUserSalseLeadData,
  setUsersData,
  setUsersDataCreditLimit,
  setSecondaryUsersData
} = userManagementSlice.actions;
export default userManagementSlice.reducer;
